import { Link } from "react-router";

export function NotFoundPage() {
  return (
    <div className="bg-background flex min-h-screen flex-col items-center justify-center px-4">
      <p className="boi-eyebrow text-muted">Board of Innovation internal</p>
      <h1 className="boi-display font-heading text-primary mt-4 text-6xl sm:text-7xl">404</h1>
      <p className="text-muted mt-4 text-lg">This route isn&apos;t part of the facilitation flow.</p>
      <Link
        to="/home"
        className="bg-accent text-accent-foreground hover:bg-accent/90 mt-8 rounded-md px-6 py-2 text-sm font-medium"
      >
        Return to workspace
      </Link>
    </div>
  );
}
